<template>
  <div>
    <section>
      <h1>Patch list items</h1>
      <div>
        <button class="is-primary" @click="convertAll">
          Start Conversion
        </button>
      </div>

      <div v-if="converting">
        <p>Company {{companiesConverted}}/{{companies.length}} Converted</p>
      </div>

      <div>
        <ul>
          <li v-for="site in sitesConverted" :key="site.id">{{ site }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'

import {readCompanySitePagesData} from '@/lib/pages'

import {readCompanySitePageListsData} from '@/lib/lists'

import {
  updateCompanySitePageListListItemData,
  readCompanySitePageListListItemsData
} from '@/lib/list_items'

import {readListTypesData} from '@/lib/list_types'

export default {
  name: 'ReplaceStandardLists',

  mixins: [page, pagination],

  data() {
    return {
      converting: false,
      companiesConverted: 0,
      success: false,
      steppingThrough: false,
      companies: [],
      sitesConverted: [],
      company: {},
      site: {},
      selectedSite: {},
      siteId: '',
      sites: [],
      page: {},
      list: {},
      hasImages: [
        'slideshow',
        'feature-blocks',
        'text-image',
        'image-cards',
        'image-grid',
        'basic-gallery',
        'mini-carousel',
        'team-members'
      ],
      lists: [],
      listTypes: [],
      errors: {},
      siteGalleries: [],
      galleryId: '',
      basicGalleryId: ''
    }
  },

  computed: {
    listHasImages() {
      return (list) => {
        let name = this.listTypes.find((type) => type.id === list.list_type_id)
          .name
        return this.hasImages.includes(name)
      }
    },

    featureBlocksId() {
      return this.listTypes.find((type) => type.name === 'feature-blocks').id
    },

    slideshowBlocksId() {
      return this.listTypes.find((type) => type.name === 'slideshow').id
    },

    textImageBlocksId() {
      return this.listTypes.find((type) => type.name === 'text-image').id
    },

    imageCardsBlocksId() {
      return this.listTypes.find((type) => type.name === 'image-cards').id
    },

    imageGridBlocksId() {
      return this.listTypes.find((type) => type.name === 'image-grid').id
    },

    basicGalleryBlocksId() {
      return this.listTypes.find((type) => type.name === 'basic-gallery').id
    },

    miniCarouselBlocksId() {
      return this.listTypes.find((type) => type.name === 'mini-carousel').id
    },

    teamMemberBlocksId() {
      return this.listTypes.find((type) => type.name === 'team-members').id
    }
  },

  methods: {
    getData() {
      readCompaniesData({page: 1, page_size: 250}).then(({data, page}) => {
        this.companies = data
        this.pageData = page
      })

      readListTypesData().then(({data}) => {
        this.listTypes = data
      })
    },

    convertAll() {
      this.converting = true

      this.companies.forEach((company, index) => {
        window.setTimeout(() => {
          this.getSites(company.id)
          this.companiesConverted++
        }, 2000 * index)
      })
    },

    getSites(companyId) {
      readCompanySitesData(companyId, {page: 1, page_size: 250}).then(
        ({data}) => {
          let sites = data

          if (sites.length) {
            sites.forEach((site, index) => {
              window.setTimeout(() => {
                this.handleImageChange(companyId, site.id)
                this.sitesConverted.push(site.name)
                this.siteId = site.id
              }, 3000 * index)
            })
          }
        }
      )
    },

    updateListListItem(companyId, siteId, pageId, list, listItemId, image, index) {
      let img = {image: image}
      let newIndex = 1

      window.setTimeout(() => {
        newIndex++

        updateCompanySitePageListListItemData(
          companyId,
          siteId,
          pageId,
          list.id,
          listItemId,
          img
        ).then(({data}) => {
        })
      }, 1000 * newIndex)
    },

    handleImageChange(companyId, siteId) {
      readCompanySitePagesData(companyId, siteId).then(({data}) => {
        let pages = data

        if (pages.length) {
          pages.forEach((page) => {
            let pageId = page.id

            readCompanySitePageListsData(companyId, siteId, pageId).then(
              ({data}) => {
                let lists = data

                if (lists) {
                  lists.forEach((list) => {
                    if (this.listHasImages(list)) {
                      readCompanySitePageListListItemsData(
                        companyId,
                        siteId,
                        pageId,
                        list.id,
                        {page: 1, page_size: 250}
                      ).then(({data}) => {
                        let listItems = data

                        if (listItems) {
                          listItems.forEach((listItem, index) => {
                            let listItemId = listItem.id
                            let image

                            if (list.list_type_id === this.featureBlocksId) {
                              image = JSON.parse(listItem.value).image || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.slideshowBlocksId) {
                              image = JSON.parse(listItem.value).image_url || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.textImageBlocksId) {
                              image = JSON.parse(listItem.value).image_url || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.imageCardsBlocksId) {
                              image = JSON.parse(listItem.value).image_url || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.imageGridBlocksId) {
                              image = JSON.parse(listItem.value).image || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.basicGalleryBlocksId) {
                              image = JSON.parse(listItem.value).url || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.miniCarouselBlocksId) {
                              image = JSON.parse(listItem.value).image_url || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }

                            if (list.list_type_id === this.teamMemberBlocksId) {
                              image = JSON.parse(listItem.value).image || false

                              if (image) {
                                this.updateListListItem(
                                  companyId,
                                  siteId,
                                  pageId,
                                  list,
                                  listItemId,
                                  image,
                                  index
                                )
                              }
                            }
                          })
                        }
                      })
                    }
                  })
                }
              }
            )
          })
        }
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass"></style>
